/* @ngInject */
function iframeOnload() {
  return {
    scope: {
      callBack: '&iframeOnload',
    },
    restrict: 'A',
    link(scope, element) {
      element.on('load', () => (
        scope.callBack({ element: element[0].src })
      ));
    },
  };
}

export default iframeOnload;



// WEBPACK FOOTER //
// ./client/components/iframe-onload/iframe-onload.directive.js